<template>
  <div class="add-dialog">
    <el-dialog title="新增角色" :visible.sync="addVisible" :before-close="addCancel">
      <el-form :model="addForm" :rules="rules" ref="ruleForm">
        <el-form-item label="角色名称" :label-width="formLabelWidth" prop="name">
          <el-col :span="10">
            <el-input  v-model="addForm.name" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="角色描述" :label-width="formLabelWidth" prop="desc">
          <el-col :span="10">
            <el-input  v-model="addForm.desc" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="选择权限" :label-width="formLabelWidth" prop="menuIds">
          
          <el-select
            v-model="addForm.menuIds"
            multiple
            filterable
            allow-create
            default-first-option
            style="width: 70%"
            placeholder="请选择权限"
            
            >
            <el-option-group
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              class="add-dialog-menuIds"
              >
                <el-option
                  v-for="op in item.childMenu"
                  :key="op.id"
                  :label="op.name"
                  :value="op.id+','+item.id"
                  >
                  {{op.name}}
                </el-option>
          </el-option-group>
            <!-- <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option> -->
          </el-select>
        
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCancel">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    addVisible:{
      type: Boolean,
      default:  false
    },
    options: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      addForm: {
        name: "",
        desc: '',
        menuIds: []
      },
      // options: [
      //   {
      //     id: 1,
      //     value: '超级管理员',
      //     label: '超级管理员'
      //   },
      //   {
      //     id: 2,
      //     value: '普通管理员',
      //     label: '普通管理员'
      //   },
      // ],
      rules: {
        name: [
            { required: true, message: '请输入角色名称', trigger: 'blur' },
            { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
          ],
          desc: [
        { required: true, message: '请输入角色描述', trigger: 'blur' }
        ],
        menuIds: [
            { required: true, message: '请选择角色权限', trigger: 'change' }
          ],
      },
      formLabelWidth:'120px'
    }
  },
  methods: {
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //       if (valid) {
    //         alert('submit!');
    //       } else {
    //         console.log('error submit!!');
    //         return false;
    //       }
    //     });
    //   },
      addConfirm(){
        let str = ''
        this.addForm.menuIds.forEach(el => {
          str+=','+el
        })
        const menuIds =Array.from(new Set(str.slice(1, str.length).split(',')));
        const {name, desc} = this.addForm
        const params = {
          name: name,
          desc: desc,
          menuIds: menuIds
        }
        const _this = this
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            _this.$emit('addConfirm', params)
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      addCancel(){
        this.$emit('addCancel', false)
      }
  }
}
</script>

<style lang="scss">
  .add-dialog{
    /deep/ .el-form{
      .el-input{
        width: 150px;
      }
    }
  }
  .el-select-dropdown{
    .add-dialog-menuIds{
      .el-select-group{
        .el-select-dropdown__item{
          padding-left: 45px;
        }
        
      }
    }
  }
</style>